module.exports = __webpack_public_path__ + "img/btn-red-short.411f43b5.png";